
import { Node, Edge } from "@xyflow/react";
import { downloadFile } from "./common";

/**
 * Generates CSV data for Google Sheets export
 */
export const exportToSheetsCsv = (nodes: Node[], edges: Edge[]): string => {
  // Define columns for the CSV
  const headers = ['ID', 'Type', 'X Position', 'Y Position', 'Category', 'Content', 'Connected To'];
  let csv = headers.join(',') + '\n';
  
  // Create a map of connections for each node
  const nodeConnections = new Map<string, string[]>();
  edges.forEach(edge => {
    if (!nodeConnections.has(edge.source)) {
      nodeConnections.set(edge.source, []);
    }
    nodeConnections.get(edge.source)?.push(edge.target);
  });
  
  // Add nodes to the CSV
  nodes.forEach(node => {
    const connections = nodeConnections.get(node.id) || [];
    const connectionString = connections.length > 0 ? `"${connections.join(', ')}"` : '';
    
    // Ensure content and category are strings and properly escaped for CSV
    const content = node.data.label ? `"${String(node.data.label).replace(/"/g, '""')}"` : '';
    const category = node.data.category ? `"${String(node.data.category).replace(/"/g, '""')}"` : '';
    
    const row = [
      node.id,
      node.type || 'node',
      Math.round(node.position.x),
      Math.round(node.position.y),
      category,
      content,
      connectionString
    ];
    
    csv += row.join(',') + '\n';
  });
  
  return csv;
};

/**
 * Handles exporting to Google Sheets
 */
export const exportToSheets = (nodes: Node[], edges: Edge[], title: string = "Whiteboard"): void => {
  try {
    const csvContent = exportToSheetsCsv(nodes, edges);
    // Ensure title is a string and properly sanitized
    const safeTitle = String(title).replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const fileName = `${safeTitle}_export.csv`;
    downloadFile(csvContent, fileName, 'text/csv');
  } catch (error) {
    console.error("Failed to export to Sheets:", error);
    throw error;
  }
};
